import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from "redux";
import themeReducer from './Features/themeSlice'
import carReducer from './Features/carSlice'
import tncReducer from './Features/tnCSlice'
import modelReducer from './Features/modelSlice'
import breakinReducer from './Features/breakinSlice'
import isClaimReducer from './Features/isClaimSlice'
import locationReducer from './Features/locationSlice'
import isPAYDReducer from './Features/isPAYDSlice'
import damageReducer from './Features/damageSlice'
import isUploadLaterReducer from "./Features/uploadLaterSlice";
import authReducer from './Features/authSlice';

import { persistReducer, persistStore, createTransform } from 'redux-persist';
import createIdbStorage from 'redux-persist-indexeddb-storage';

// Define a reset action type
const RESET_APP_STATE = 'RESET_APP_STATE';

// Create IndexedDB storage instance (no quota limits!)
const storage = createIdbStorage({
    name: 'ReduxPersistDB',
    storeName: 'reduxStore'
});

// Transform to remove blobs if still needed
const carTransform = createTransform(
    (inboundState, key) => {
        if (key === 'car') {
            return {
                ...inboundState,
                cars: inboundState.cars?.map(car => ({
                    ...car,
                    uploadBlob: null,      // Still remove blobs - use your existing IndexedDB for these
                    uploadImg: null,
                })) || []
            };
        }
        return inboundState;
    },
    (outboundState, key) => {
        return outboundState;
    },
    { whitelist: ['car'] }
);

// Combine the reducers
const appReducer = combineReducers({
    theme: themeReducer,
    car: carReducer,
    tnc: tncReducer,
    model: modelReducer,
    breakin: breakinReducer,
    isClaim: isClaimReducer,
    location: locationReducer,
    isPAYD: isPAYDReducer,
    damage: damageReducer,
    isUploadLater: isUploadLaterReducer,
    auth: authReducer,
});

// Root reducer with reset capability
const rootReducer = (state, action) => {
    if (action.type === RESET_APP_STATE) {
        state = undefined;
    }
    return appReducer(state, action);
};

const persistConfig = {
    key: "user",
    storage: storage, // IndexedDB - no quota limits!
    transforms: [carTransform],
    // You can now persist everything if needed
    blacklist: ['theme'], // Only exclude non-essential data
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        }
    }),
});

export const persistor = persistStore(store);

export const resetAppState = () => ({ type: RESET_APP_STATE });